import React, { useState, useEffect } from 'react';
import { Card, CardHeader, CardBody, Label, FormGroup, Input, Container, Row, Col } from 'reactstrap';
import Select from 'react-select';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import BasicDetailsForm from './businessUnitNewUI';
import IsCoreMaster from 'views/pages/manage/common/commonComponents/coreMaster';
import LocationDetailsForm from './LocationDetailsForm';
import ContactDetailsForm from './ContactDetailsForm';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import FeatureSetup from './FeatureSetup';
import ReceiptIndex from './ReceiptIndex';
import Sidebar from './Sidebar';
import { fieldMap, menuItems } from './constant';
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import { inputStyle } from 'views/pages/manage/masters/schoolMaster/schoolInfo/constant';
import CscMapping from './CscMapping.jsx';
import PaymentGateway from './PaymentGateway.jsx';
import ThirdPartyMapping from './ThirdPartyMapping';
import TaxMapping from './TaxMapping';
import Logs from './Logs';
import WarningDialoge from './WarningDialog';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';

const basicInitialDetail = {
  businessAreaKey: '',
  businessAreaDispValue: '',
  businessAreaDesc: '',
  region: [],
  currency: '',
  groupCode: '',
  companyCode: '',
  campusInstitution: '',
  jurisdiction: '',
  serviceTaxRegistration: '',
  // gstInNumber: '',
  stateCode: '',
  cinllpNumber: '',
  tid: '',
  referenceId: '',
  branchDisplayName: '',
  businessUnitType: [],
  status: { sfWb: 'ACTIVE', phx: 'ACTIVE' },
  statusSalesforceWebsite: '',
  updatedOn: '',
  effectiveDate: '',
  acadOrg: '',
  academicCareer: [],
  academicGroup: [],
  academicClass: [],
  sapPlantId: '',
  sapBusinessArea: '',
  sapDescription: '',
  businessPlaceCode: '',
  defermentBusinessArea: '',
  gstInNumber: '',
  buUrlName: '',
  buUrl: '',
  franchiseType: '',
  franchiseBusinessName: '',
  franchiseRegisteredAddress: '',
  franchiseSubType: '',
  testTypeIds: []
}

const BusinessUnitFormTabs = ({
    locationAndContactDetailsData,
    fetchLocationAndContactDetails = () => { },
    fetchBusinessAreaDetails = () => { },
    setStatus,
    ...props
}) => {

    const [buId, setBuId] = useState(props.formId)
    const [isEdit, setIsEdit] = useState(false)
    // const [selectedTab, setSelectedTab] = useState(menuItems?.[0])
    // const TAB=selectedTab?.component
    const [isOpen, setOpen] = useState(false)
    const [selectedTabValue, setSelectedTabValue] = useState(menuItems?.[0]);
    const [dropdowns, setDropdowns] = useState({})
    const [isTabFilled, setFilled] = useState({ basicDetail: true })
     const [basicDetail, setBasicDetail] = useState(basicInitialDetail);

    const handleTabChange = (item) => {
        if (isEdit) {
            setOpen(true)
            return;
        }
        const prevTab = menuItems?.[item?.id - 2]
        if ((buId !== null && buId !== undefined) && (isTabFilled?.[(prevTab)?.key] || [1, 7, 8, 9, 10].includes(item?.id) || props?.action == 'view')) {
            setSelectedTabValue(item);
        }
        else {
            failureToast(`Please fill and save the ${prevTab?.label} tab before accessing the ${item?.label} tab. Tabs must be completed in order up to CSC Mapping.`);
        }
    };


    // const theme = createTheme({
    //     palette: {
    //         primary: {
    //             main: '#262626',
    //         },
    //         secondary: {
    //             main: '#00AEEF',
    //         },
    //     },
    // });

    useEffect(() => {
        fetchLocationAndContactDetails();
        fetchBusinessAreaDetails();
        setBuId(props?.formId);
    }, [props?.formId])

    return (
        <>
            {props?.action != 'view' && props?.action != 'edit' ? (
                <Card style={{ width: '100%', marginTop: '-31px' }} className='p-2 mb-3'>
                    <div className='d-flex justify-content-between align-items-center'>
                        <div className='d-flex align-items-center justify-content-start'>
                            <div className="dark-text label-color">Business Area</div>
                            {/* <IsCoreMaster master={'businessArea'} masterDisplayValue={'Business Area'} /> */}
                        </div>
                        <div className='d-flex  align-items-center justify-content-end' style={{ width: '25%', gap: '20px' }}>
                            <h5>Copy From BU</h5>
                            {props?.businessAreaList ? (
                                <div style={{ width: '50%' }}>
                                    <AAutoComplete
                                        placeholder="Select"
                                        currentValue={props.copyBusinessArea}
                                        handleChange={(value) => {
                                            props.setCopyBusinessArea(value)
                                        }}
                                        items={props?.businessAreaList}
                                        isMulti={false}
                                        isShowCount={false}
                                        style={{ control: inputStyle }}
                                        isInputChange={true}
                                        isDisabled={''}
                                    />
                                </div>
                                // <AAutoComplete
                                //     value={}
                                //     id="example1cols1Input"
                                //     options={}
                                //     isDisabled={props?.isPrevious}
                                //     onChange={sData => {
                                //         // resetValues();
                                //         ;
                                //     }}
                                //   onChange={ ( sData ) => {
                                //   // //////console.log(sData.value)
                                //     setSelectedCode( preState => ( { ...preState, groupCodeId: sData.value } ) );
                                //   getCompanyCode(sData.value);
                                //   setValue({ ...value, groupCode: sData });
                                // }}
                                // />
                            ) : (
                                <span>Loading List ...</span>
                            )}
                        </div>
                    </div>
                </Card>
            ) : null}

            <div className="d-flex mr-2 " style={{ height: '76vh', overflow: 'hidden' }}>
                {/* Sidebar in a Card */}
                <Sidebar
                    selectedTab={selectedTabValue}
                    setSelectedTab={setSelectedTabValue}
                    handleTabChange={handleTabChange}
                    fieldMap={fieldMap}
                    menuItems={menuItems}
                />

                <div className="" style={{ width: '70%', overflowY: 'auto', flexGrow: 1 }}>
                    <BasicDetailsForm
                        {...props}
                        selectedTabValue={selectedTabValue}
                        setBuId={setBuId}
                        setSelectedTabValue={setSelectedTabValue}
                        isEdit={isEdit}
                        setIsEdit={setIsEdit}
                        dropdowns={dropdowns}
                        setDropdowns={setDropdowns}
                        setStatus={setStatus}
                        fetchBusinessAreaDetails={fetchBusinessAreaDetails}
                        value={basicDetail}
                        setValue={setBasicDetail}
                    />
                    <LocationDetailsForm
                        isEdit={isEdit}
                        setIsEdit={setIsEdit}
                        selectedTabValue={selectedTabValue}
                        action={props?.action}
                        buId={buId}
                        locationDetails={locationAndContactDetailsData?.data[0]}
                        locationDetailsFetching={locationAndContactDetailsData?.fetching}
                        setSelectedTabValue={setSelectedTabValue}
                        fetchLocationAndContactDetails={fetchLocationAndContactDetails}
                        dropdowns={dropdowns}
                        setDropdowns={setDropdowns}
                        setFilled={setFilled}
                    />

                    <ContactDetailsForm
                        isEdit={isEdit}
                        setIsEdit={setIsEdit}
                        selectedTabValue={selectedTabValue}
                        action={props?.action}
                        buId={buId}
                        contactDetails={locationAndContactDetailsData?.data[1]}
                        contactDetailsFetching={locationAndContactDetailsData?.fetching}
                        fetchLocationAndContactDetails={fetchLocationAndContactDetails}
                        dropdowns={dropdowns}
                        setDropdowns={setDropdowns}
                        setFilled={setFilled}
                        basicDetail={basicDetail}
                    />


                    <FeatureSetup
                        isEdit={isEdit}
                        setIsEdit={setIsEdit}
                        buId={buId}
                        selectedTabValue={selectedTabValue}
                        action={props?.action}
                        dropdowns={dropdowns}
                        setDropdowns={setDropdowns}
                        setFilled={setFilled}
                    />

                    <ReceiptIndex
                        isEdit={isEdit}
                        setIsEdit={setIsEdit}
                        buId={buId}
                        selectedTabValue={selectedTabValue}
                        dropdowns={dropdowns}
                        setDropdowns={setDropdowns}
                        setFilled={setFilled}
                    />
                    <CscMapping
                        isEdit={isEdit}
                        setIsEdit={setIsEdit}
                        buId={buId}
                        selectedTabValue={selectedTabValue}
                        action={props?.action}
                        dropdowns={dropdowns}
                        setDropdowns={setDropdowns}
                        setFilled={setFilled}
                    />
                    <PaymentGateway
                        isEdit={isEdit}
                        setIsEdit={setIsEdit}
                        buId={buId}
                        selectedTabValue={selectedTabValue}
                        action={props?.action}
                        dropdowns={dropdowns}
                        setDropdowns={setDropdowns}
                        setFilled={setFilled}
                    />
                    <ThirdPartyMapping
                        isEdit={isEdit}
                        setIsEdit={setIsEdit}
                        buId={buId}
                        selectedTabValue={selectedTabValue}
                        action={props?.action}
                        dropdowns={dropdowns}
                        setDropdowns={setDropdowns}
                        setFilled={setFilled}
                        fetchBusinessAreaDetails={fetchBusinessAreaDetails}
                    />
                    <TaxMapping
                        isEdit={isEdit}
                        setIsEdit={setIsEdit}
                        buId={buId}
                        selectedTabValue={selectedTabValue}
                        action={props?.action}
                        dropdowns={dropdowns}
                        setDropdowns={setDropdowns}
                    />
                    <Logs
                        buId={buId}
                        selectedTabValue={selectedTabValue}
                        action={props?.action}
                        dropdowns={dropdowns}
                        setDropdowns={setDropdowns}
                    />
                    <WarningDialoge isOpen={isOpen} setOpen={setOpen} title={"Unsaved changes"} subheading='Please save the changes before proceeding further' />
                </div>
            </div>

        </>

    );
}

export default BusinessUnitFormTabs;